import { useEffect, useState } from "react";
import { Image } from "../Image";

export type IconName =
    | "box"
    | "box-tilt"
    | "box-disabled"
    | "box-hover"
    | "video"
    | "video-disabled"
    | "video-hover"
    | "video-dark"
    | "pdf"
    | "pdf-disabled"
    | "pdf-hover"
    | "next"
    | "up"
    | "toggle-up"
    | "down"
    | "toggle-down"
    | "left"
    | "left-disabled"
    | "toggle-left"
    | "plus"
    | "minus"
    | "magnifying-glass"
    | "sync"
    | "logo"
    | "airplane"
    | "envelope"
    | "envelope-disabled"
    | "x"
    | "sad-emoji"
    | "confused-emoji"
    | "curious-emoji"
    | "happy-with-crown"
    | "open-menu"
    | "close-menu"
    | "switch"
    | "logout"
    | "circle"
    | "checked"
    | "person"
    | "pencil"
    | "video-play"
    | "video-pause"
    | "video-replay"
    | "video-skip"
    | "video-fullscreen"
    | "video-fullscreen-exit"
    | "location"
    | "trophy"
    | "trophy-empty"
    | "warehouse"
    | "user-add"
    | "settings"
    | "star"
    | "star-empty"
    | "sun"
    | "info";

interface IconProps {
    name: IconName;
    width?: number;
    height?: number;
    transition?: boolean;
    disabled?: boolean;
    priority?: boolean;
}

export const Icon = ({
    name,
    width = 20,
    height = 20,
    transition = true,
    disabled = false,
    priority = false,
}: IconProps) => {
    const [src, setSrc] = useState<string | null>(null);

    useEffect(() => {
        const filename = disabled ? `${name}-disabled` : name;
        import(`./${filename}.svg`)
            .then((module) => module.default)
            .then((src) => setSrc(src));
    }, [name, disabled]);

    return (
        <Image
            src={src}
            width={width}
            height={height}
            alt={name}
            transition={transition}
            priority={priority}
        />
    );
};
